<span class="html-snackbar-message">
  @for (part of data.messageParts; track part) { @if (part.bold) {
  <span class="bold-text">{{ part.text }}</span>
  } @if (!part.bold) {
  <span>{{ part.text }}</span>
  } }
</span>
@if (data.action) {
<span class="html-snackbar-action">
  <button
    matSnackBarAction
    type="button"
    (click)="snackBarRef.dismissWithAction()"
  >
    {{ data.action }}
  </button>
</span>
}
